import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"height":"100%"},
  align: "Center"
}
const _hoisted_2 = { id: "overall-body" }
const _hoisted_3 = {
  id: "body-container",
  align: "left"
}
const _hoisted_4 = {
  id: "body-table",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_5 = { id: "main-container" }
const _hoisted_6 = {
  width: "100%",
  cellspacing: "5",
  cellpadding: "0",
  border: "0"
}
const _hoisted_7 = { valign: "top" }
const _hoisted_8 = {
  valign: "top",
  align: "left"
}
const _hoisted_9 = { class: "full-width" }
const _hoisted_10 = {
  width: "100%",
  cellspacing: "0",
  cellpadding: "0",
  border: "0"
}
const _hoisted_11 = { colspan: "2" }
const _hoisted_12 = { class: "compass-red" }
const _hoisted_13 = { colspan: "2" }
const _hoisted_14 = { colspan: "2" }
const _hoisted_15 = { style: {"margin":"10px 0"} }
const _hoisted_16 = {
  width: "100%",
  cellspacing: "0",
  cellpadding: "0",
  border: "0"
}
const _hoisted_17 = { style: {"margin":"10px 0","font-style":"italic"} }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { style: {"margin":"10px 0"} }
const _hoisted_21 = { style: {"min-height":"150px","display":"flex"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.$store.getters.isInternalUser)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_5, [
                    _createElementVNode("table", _hoisted_6, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", _hoisted_7, [
                          _createElementVNode("td", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("table", _hoisted_10, [
                                _createElementVNode("tbody", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.propertyData.propertyId), 1)
                                  ]),
                                  _cache[3] || (_cache[3] = _createElementVNode("tr", null, [
                                    _createElementVNode("td", { colspan: "2" }, " ")
                                  ], -1)),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", null, _toDisplayString(_ctx.formattedDate(new Date)), 1),
                                    _cache[0] || (_cache[0] = _createElementVNode("td", { style: {"text-transform":"uppercase","font-size":"16px","font-weight":"bold"} }, " Form 12a ", -1)),
                                    _cache[1] || (_cache[1] = _createElementVNode("td", null, null, -1))
                                  ]),
                                  _cache[4] || (_cache[4] = _createElementVNode("tr", null, [
                                    _createElementVNode("td", { colspan: "2" }, " ")
                                  ], -1)),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", null, _toDisplayString(_ctx.supplier.companyName), 1),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.supplierMainContact.email), 1)
                                    ]),
                                    _cache[2] || (_cache[2] = _createElementVNode("td", null, null, -1))
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.supplier.postalAddress), 1)
                                  ]),
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.supplier.city), 1)
                                  ])
                                ])
                              ]),
                              _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                              _cache[24] || (_cache[24] = _createElementVNode("div", { style: {"margin":"10px 0"} }, [
                                _createElementVNode("span", { style: {"text-transform":"uppercase","font-weight":"bold","font-size":"18px","letter-spacing":"1px"} }, [
                                  _createTextVNode("Certificate of compliance with inspection,"),
                                  _createElementVNode("br"),
                                  _createTextVNode("maintenance and reporting procedures")
                                ]),
                                _createElementVNode("br"),
                                _createElementVNode("span", { style: {"font-style":"italic","font-weight":"bold"} }, "Section 108 (3)(c) Building Act 2004")
                              ], -1)),
                              _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("table", _hoisted_16, [
                                  _createElementVNode("tbody", null, [
                                    _cache[18] || (_cache[18] = _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        colspan: "2",
                                        class: "title"
                                      }, "The Building")
                                    ], -1)),
                                    _createElementVNode("tr", null, [
                                      _cache[5] || (_cache[5] = _createElementVNode("td", null, "Compliance Schedule No:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.bwof.complianceSchedule), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[6] || (_cache[6] = _createElementVNode("td", null, "Warrant of Fitness Expiry Date:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.formattedDate(_ctx.service.whenNextServiceAnniversary)), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[7] || (_cache[7] = _createElementVNode("td", null, "Street Address of Building:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.propertyData.streetAddress) + " " + _toDisplayString(_ctx.propertyData.suburb) + " " + _toDisplayString(_ctx.propertyData.city), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[8] || (_cache[8] = _createElementVNode("td", null, "Legal Description:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.bwof.legalDescription), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[9] || (_cache[9] = _createElementVNode("td", null, "Building Name:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.propertyData.buildingName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[10] || (_cache[10] = _createElementVNode("td", null, "Location of Building within site/block number:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.bwof.locationOfBuildingWithinSite), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[11] || (_cache[11] = _createElementVNode("td", null, "Level/Unit Number:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.bwof.levelUnitNo), 1)
                                    ]),
                                    _cache[19] || (_cache[19] = _createElementVNode("tr", null, [
                                      _createElementVNode("td", { colspan: "2" }, " ")
                                    ], -1)),
                                    _cache[20] || (_cache[20] = _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        colspan: "2",
                                        class: "title"
                                      }, "The Owner")
                                    ], -1)),
                                    _createElementVNode("tr", null, [
                                      _cache[12] || (_cache[12] = _createElementVNode("td", null, "Name of Owner:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.owner.companyName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[13] || (_cache[13] = _createElementVNode("td", null, "Contact Person:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.ownerContact.firstName) + " " + _toDisplayString(_ctx.ownerContact.lastName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[14] || (_cache[14] = _createElementVNode("td", null, "Mailing Address:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.owner.postalAddress) + " " + _toDisplayString(_ctx.owner.suburb) + " " + _toDisplayString(_ctx.owner.city), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[15] || (_cache[15] = _createElementVNode("td", null, "Street Address:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.owner.streetAddress), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[16] || (_cache[16] = _createElementVNode("td", null, "Email Address:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.ownerContact.email), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _cache[17] || (_cache[17] = _createElementVNode("td", null, "Contact Number:", -1)),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.ownerContact.ddi && _ctx.ownerContact.ddi.trim() !== '' ? _ctx.ownerContact.ddi : _ctx.ownerContact.mobile), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("div", _hoisted_17, [
                                _cache[21] || (_cache[21] = _createTextVNode(" The inspection, maintenance and reporting procedures of the Compliance Schedule have been fully complied with during the ", -1)),
                                (_ctx.bwof.complianceScheduleMonths == 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.bwof.complianceScheduleMonths) + " month", 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.bwof.complianceScheduleMonths) + " months", 1)),
                                _cache[22] || (_cache[22] = _createTextVNode(" prior to the date stated below in relation to the following specified system/s ", -1))
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("table", _hoisted_21, [
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleServices, (srv) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: srv.serviceId
                                      }, [
                                        _createElementVNode("td", null, [
                                          _createElementVNode("span", null, _toDisplayString(srv.ref), 1)
                                        ]),
                                        _createElementVNode("td", null, _toDisplayString(srv.serviceName), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]),
                              _cache[27] || (_cache[27] = _createElementVNode("div", { style: {"margin":"10px 0"} }, [
                                _createElementVNode("table", {
                                  class: "signature",
                                  width: "100%"
                                }, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", null, "Signed:"),
                                      _createElementVNode("td", null, "Name:")
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", null, "Date:"),
                                      _createElementVNode("td", null, "Position:")
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", { colspan: "2" }, "IQP Registration No:")
                                    ])
                                  ])
                                ])
                              ], -1))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}